export const sejamCheckText = {
  getSejamInfo: 'دریافت اطلاعات سجام',
  sejamRegister: 'به روزرسانی وضعیت سجام',
  officialNotice: 'اطلاعیه رسمی از سازمان بورس و اوراق بهادار',
  updateNotice:
    'کاربر گرامی با توجه به ابلاغیه جدید سازمان بورس، لازم است اطلاعات سجامی شما را دریافت کنیم. به این منظور، یک کد تایید به شماره همراهی که در سجام ثبت کرده‌اید، ارسال می‌شود. با وارد کردن این کد، اطلاعات به روز شما را دریافت خواهیم کرد',
  registerNotice:
    'کاربر گرامی، مطابق ابلاغیه سازمان بورس مبنی بر لزوم سجامی شدن سرمایه گذاران حقیقی، برای جلوگیری از ایجاد محدودیت هایی مانند ارسال سفارش های خرید و فروش، لازم است نسبت به ثبت نام و احراز هویت سجام اقدام کنید.',
  ResponsibilityNotice:
    'در نظر داشته باشید که مسئولیت تمامی آثار و پیامدهای ناشی از انجام ندادن این فرآیند، بر عهده شما خواهد بود.',
  alreadyRegisteredNotice:
    ' اگر قبلاً در سجام ثبت نام و احراز هویت کرده اید اما وضعیت پرونده شما هنوز در سامانه ما نمایش داده نمی‌شود، می‌توانید با مراجعه به سامانه اکسپرس، اطلاعات خود را به روزرسانی کنید.',
  getConfirmationCode: 'دریافت کد تایید ',
  registerInSejam: 'ثبت نام در سجام',
  callSejamInfo: 'فراخوانی اطلاعات از سجام',
  resendTimeNotElapsed: 'زمان ارسال درخواست مجدد به پایان نرسیده است',
  updateSejamInfoSuccess: 'اطلاعات سجام با موفقیت به روز رسانی شد.',
  sejamProfileUrl: 'https://ex.agah.com/reg/login/',
};
